import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CollisionPath, DependencyCollisionInfo } from '../services/application.do';


@Component({
  selector: 'app-dependency-collision-info',
  templateUrl: './dependency-collision-info.component.html',
  styleUrls: ['./dependency-collision-info.component.scss'],
  standalone: false
})
export class DependencyCollisionInfoComponent {

  constructor(
    private dialogRef: MatDialogRef<DependencyCollisionInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DependencyCollisionInfo
  ) {
  }

  /**
   * Format a versioned dependency path with package names and versions
   */
  formatVersionedPath(collisionPath: CollisionPath, conflictingPackage: string): { segment: string, isConflicting: boolean }[] {
    return collisionPath.versionedPath.map(node => {
      const isConflicting = node.name === conflictingPackage;
      return {
        segment: `${node.name}@${node.version}`,
        isConflicting
      };
    });
  }

  onCloseClicked(): void {
    this.dialogRef.close();
  }
}